import config from "../../config";
import {
    GET_ONGOING_BOOKINGS,
    GET_PENDING_BOOKINGS,
    LOAD_MORE_PENDING_BOOKINGS,
    LOAD_MORE_ONGOING_BOOKINGS,
    GET_COMPLETED_BOOKINGS,
    LOAD_MORE_COMPLETED_BOOKINGS,
    GET_CANCELLED_BOOKINGS,
    LOAD_MORE_CANCELLED_BOOKINGS,
} from "./types";

export const GetBookingsAction = (status) => async (dispatch, getState) => {
    try {
        let dispatchType;
        if (status == "Pending") {
            dispatchType = GET_PENDING_BOOKINGS;
        } else if (status == "Progress") {
            dispatchType = GET_ONGOING_BOOKINGS;
        } else if (status == "Completed") {
            dispatchType = GET_COMPLETED_BOOKINGS;
        } else if (status == "Cancelled") {
            dispatchType = GET_CANCELLED_BOOKINGS;
        }
        const token = getState().auth.token;
        const headers = config.bearerHeaders(token);
        let url = config.services.customerBookings(status);
        if (getState().auth.user.role == 2) {
            url = config.services.careGiverBookings(status);
        }
        const res = await config.getApi(url, headers);
        if (res) {
            dispatch({ type: dispatchType, payload: res.response.data });
        }
    } catch (e) {
        console.log(e);
    }
};

export const LoadMoreBookingsAction =
    (status) => async (dispatch, getState) => {
        try {
            let dispatchType, url;
            if (status == "Pending") {
                dispatchType = LOAD_MORE_PENDING_BOOKINGS;
                url = getState().bookings.pending.next_page_url;
            } else if (status == "Progress") {
                dispatchType = LOAD_MORE_ONGOING_BOOKINGS;
                url = getState().bookings.ongoing.next_page_url;
            } else if (status == "Completed") {
                dispatchType = LOAD_MORE_COMPLETED_BOOKINGS;
                url = getState().bookings.completed.next_page_url;
            } else if (status == "Cancelled") {
                dispatchType = LOAD_MORE_CANCELLED_BOOKINGS;
                url = getState().bookings.cancelled.next_page_url;
            }
            const token = getState().auth.token;
            const headers = config.bearerHeaders(token);
            if (url) {
                const res = await config.getApi(url, headers);
                if (res) {
                    dispatch({
                        type: dispatchType,
                        payload: res.response.data,
                    });
                }
            }
        } catch (e) {
            console.log(e);
        }
    };
